export default "__VITE_ASSET__CZsn3HWS__"